import React from "react";
import { Grid, Text, Flex } from "atoms";
import { Link } from "react-router-dom";
import MemoChevronRight from "assets/icons/ChevronRightIcon";

const BreadcrumText = ({ text, color, isLink }) => (
  <Text
    fontFamily="NeometricRegular"
    my={0}
    pr="3px"
    color={color}
    firstLetterCapital
    textDecoration={isLink ? "underline" : "initial"}
  >
    {text}
  </Text>
);

const BreadcrumItem = ({ url, color, text }) =>
  url ? (
    <Link to={url}>
      <BreadcrumText text={text} color={color} isLink={!!url} />
    </Link>
  ) : (
    <BreadcrumText text={text} color={color} isLink={!!url} />
  );

export const Breadcrum = ({
  firstUrl,
  firstText,
  secondUrl,
  secondText,
  thirdText,
  thirdUrl,
  fourthText,
}) => {
  return (
    <Grid gridAutoFlow="column" jC="start" aI="center">
      <BreadcrumItem
        text={firstText}
        url={firstUrl}
        color={secondText ? "neutral.500" : "primary.900"}
      />
      {secondText && (
        <>
          <BreadcrumItem
            color={thirdText !== "" ? "neutral.500" : "primary.900"}
            text={
              <Flex aI="end" gridGap="5px">
                <MemoChevronRight height="1.6rem" />{" "}
                <Text
                  firstLetterCapital
                  fontFamily="NeometricRegular"
                  color={thirdText === "" ? "primary.900" : "neutral.500"}
                >
                  {secondText}
                </Text>
              </Flex>
            }
            url={secondUrl}
          />
        </>
      )}
      {thirdText && (
        <>
          <BreadcrumItem
            color={fourthText !== "" ? "neutral.500" : "primary.900"}
            text={
              <Flex aI="end" gridGap="5px">
                <MemoChevronRight height="1.6rem" />{" "}
                <Text firstLetterCapital fontFamily="NeometricRegular">
                  {thirdText}
                </Text>
              </Flex>
            }
            url={thirdUrl}
          />
        </>
      )}
      {fourthText && (
        <>
          <BreadcrumText
            color="primary.900"
            text={
              <Flex aI="end" gridGap="5px">
                <MemoChevronRight height="1.6rem" />{" "}
                <Text firstLetterCapital fontFamily="NeometricRegular">
                  {fourthText}
                </Text>
              </Flex>
            }
          />
        </>
      )}
    </Grid>
  );
};
